import { setTheme } from "theme/default/setTheme";

export const setFontSize_22px = setTheme(({ theme }) => `font-size: ${theme.fontSize.font_size_22px}`);
